module.exports = __webpack_public_path__ + "img/3.cbf35823.png";